// Инициализация кнопки «Наверх».

import scrollElementTo from '~/utils/animation/scrollElementTo';

/**
 * Класс, назначаемый когда кнопку нужно показать.
 */
const CLASS_VISIBLE = 'visible';

/**
 * Инициализация кнопки «Наверх».
 * 
 * @returns Функция для обработчика прокрутки страницы.
 */
function main(): ( directionDown: boolean, pageY: number ) => void
{
	const button = document.querySelector( 'body>a.up' );
	
	if ( !button )
	{
		return () => undefined;
	}
	
	let visible: boolean = button.classList.contains( CLASS_VISIBLE );
	
	button.addEventListener(
		'click',
		() =>
		{
			scrollElementTo( window, 0, 500 );
		},
	);
	
	return ( directionDown: boolean, pageY: number ) =>
	{
		if (
			visible
			&& ( directionDown || ( pageY === 0 ) )
		)
		{
			visible = false;
			button.classList.remove( CLASS_VISIBLE );
		}
		else if ( !visible && !directionDown )
		{
			visible = true;
			button.classList.add( CLASS_VISIBLE );
		}
	};
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/Scroll/buttonUp.ts